// removed by extract-text-webpack-plugin
module.exports = {"totalDiv":"PlanAllocation__totalDiv__h0-Pv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanAllocation/PlanAllocation.css
// module id = 549
// module chunks = 0